<template>
  <div
    v-if="localData.adminInfo"
    class="text-left">
    <div>
      <h5>
        <span v-text="t('forms.login_cred.IC_0010')"/>
        <i
          class="fa fa-question-circle"
          @click="showModal = true"/>
      </h5>
      <hr>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0001')"/>
        <span class="required">*</span>
        <input
          v-model="localData.adminInfo.Firstname"
          type="text"
          class="no-margin"
          maxlength="20">
        <small
          v-if="firstnameError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0008')"/>
      </label>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0002')"/>
        <span class="required">*</span>
        <input
          v-model="localData.adminInfo.Lastname"
          type="text"
          class="no-margin"
          maxlength="20">
        <small
          v-if="lastnameError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0009')"/>
      </label>

      <label>
        <span v-text="t('forms.new_contractor_contact.IC_0003')"/>
        <input
          v-model="localData.adminInfo.Title"
          type="text"
          maxlength="40">
      </label>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0005')"/>
        <span class="required">*</span>
        <input
          v-model="localData.adminInfo.Tel"
          class="no-margin"
          type="text"
          maxlength="14">
        <small
          v-if="telError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0011')"/>
      </label>

      <label>
        <span v-text="t('forms.new_contractor_contact.IC_0006')"/>
        <input
          v-model="localData.adminInfo.Cell"
          type="text"
          maxlength="14">
      </label>

      <label>
        <span v-text="t('forms.new_contractor_contact.IC_0007')"/>
        <input
          v-model="localData.adminInfo.Fax"
          type="text"
          maxlength="14">
      </label>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0008')"/>
        <span class="required">*</span>
        <input
          v-model="localData.adminInfo.Street"
          type="text"
          class="no-margin"
          maxlength="58">
        <small
          v-if="streetError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0014')"/>
      </label>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0009')"/>
        <span class="required">*</span>
        <input
          v-model="localData.adminInfo.City"
          class="no-margin"
          type="text"
          maxlength="30">
        <small
          v-if="cityError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0015')"/>
      </label>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0011')"/>
        <span class="required">*</span>
        <select
          v-model="localCountryId"
          class="no-margin">
          <option
            value="0"
            v-text="t('admin.edit_question.IC_0000')"/>
          <option
            v-for="country in localData.geoInfo.countries"
            :value="country.CountryID"
            v-text="country.Name"/>
        </select>
        <small
          v-if="countryError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0017')"/>
      </label>

      <label
        v-if="localCountryId !== '0'"
        class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0010')"/>
        <span class="required">*</span>
        <select
          v-model="localProvinceId"
          class="no-margin">
          <option
            value="0"
            v-text="t('admin.edit_question.IC_0000')"/>
          <option
            v-for="province in getProvinces()"
            :value="province.zone_id"
            v-html="province.Name"/>
        </select>
        <small
          v-if="provinceError && displayError"
          class="error"
          v-text="t('xajax.mycontactinfo.server.IC_0016')"/>
      </label>

      <label class="bottomMargin">
        <span v-text="t('forms.new_contractor_contact.IC_0012')"/>
        <span class="required">*</span>
        <input
          v-model="localData.adminInfo.Postal"
          class="no-margin"
          type="text"
          maxlength="14">
        <small
          v-if="postalError && displayError"
          class="error no-margin"
          v-text="t('xajax.mycontactinfo.server.IC_0018')"/>
        <small
          v-if="postalMatchError && displayError"
          class="error"
          v-text="t('member_basic_edit.IC_0115')"/>
      </label>
    </div>

    <div class="row">
      <div class="columns small-12 text-center">
        <button
          class="tiny navBtn"
          @click="saveAdminInfo"
          v-text="t('forms.new_blank_reference_member.IC_0024')"/>
      </div>
    </div>

    <modal
      v-if="showModal"
      :size="`small`"
      :show-close-button="true"
      @close="showModal = false">
      <p
        class="modalMargin"
        v-html="`${t('forms.login_cred.IC_0000')} ${t('forms.login_cred.IC_0001')}`"/>
    </modal>
  </div>

</template>

<script>
import $      from 'jquery';
import toastr from 'toastr';
import _      from 'lodash';
import Modal  from '../../Ui/Modal.vue';

export default {

  components: {
    Modal,
  },

  data() {
    return {
      localData: {},
      localCountryId: '0',
      localProvinceId: '0',
      displayError: false,
      showModal: false,
    };
  },

  computed: {
    firstnameError() {
      return _.isEmpty(this.localData.adminInfo.Firstname);
    },

    lastnameError() {
      return _.isEmpty(this.localData.adminInfo.Lastname);
    },

    telError() {
      return _.isEmpty(this.localData.adminInfo.Tel) || _.size(this.localData.adminInfo.Tel) < 9;
    },

    streetError() {
      return _.isEmpty(this.localData.adminInfo.Street);
    },

    cityError() {
      return _.isEmpty(this.localData.adminInfo.City);
    },

    countryError() {
      return this.localCountryId === '0';
    },

    provinceError() {
      return this.localProvinceId == 0;
    },

    postalError() {
      return _.isEmpty(this.localData.adminInfo.Postal);
    },

    postalMatchError() {
      let error = false;

      if (this.localData.adminInfo.CountryISO !== 'CA' || this.provinceError) {
        return false;
      }

      const postal = this.localData.adminInfo.Postal ? this.localData.adminInfo.Postal.replace(/[^a-z0-9]/gi, '').toUpperCase(): '';

      if (_.size(postal) !== 6) {
        error = true;
      }

      if (['W', 'Z'].includes(postal.charAt(0))) {
        error = true;
      }

      ['D', 'F', 'I', 'O', 'Q', 'U'].forEach((char) => {
        if (postal.includes(char)) {
          error = true;
        }
      });

      const regex = /^[A-Z]\d[A-Za-z]\d[A-Z]\d$/;
      const match = regex.exec(postal);

      if (!match) {
        error = true;
      }

      const provincePostalDistrictMap = new Map();

      provincePostalDistrictMap.set('AB', ['T']);
      provincePostalDistrictMap.set('BC', ['V']);
      provincePostalDistrictMap.set('MB', ['R']);
      provincePostalDistrictMap.set('NB', ['E']);
      provincePostalDistrictMap.set('NL', ['A']);
      provincePostalDistrictMap.set('NT', ['X']);
      provincePostalDistrictMap.set('NS', ['B']);
      provincePostalDistrictMap.set('NU', ['X']);
      provincePostalDistrictMap.set('ON', ['K', 'L', 'M', 'N', 'P']);
      provincePostalDistrictMap.set('PE', ['C']);
      provincePostalDistrictMap.set('NS', ['B']);
      provincePostalDistrictMap.set('QC', ['G', 'H', 'J']);
      provincePostalDistrictMap.set('SK', ['S']);
      provincePostalDistrictMap.set('YT', ['Y']);

      const firstLetter = provincePostalDistrictMap.get(this.localData.adminInfo.ProvinceISO);

      if (!_.includes(firstLetter, postal.charAt(0))) {
        error = true;
      }

      return error;
    },
  },

  watch: {
    localCountryId(val, oldVal) {
      const match = _.find(this.localData.geoInfo.countries, country =>
        country.CountryID === val);

      if (match) {
        this.localData.adminInfo.Country = match.Name;
        this.localData.adminInfo.CountryCode = match.iso_code_2;
        this.localData.adminInfo.CountryISO = match.iso_code_2;
      } else {
        this.localData.adminInfo.Country = '';
        this.localData.adminInfo.CountryCode = '';
        this.localData.adminInfo.CountryISO = '';
      }

      if (val !== oldVal && oldVal > 0) {
        this.localProvinceId = 0;
      }
    },

    localProvinceId(val) {
      const match = _.find(this.localData.geoInfo.provinces, province =>
        province.zone_id === val);

      if (match) {
        this.localData.adminInfo.Province = match.Name;
        this.localData.adminInfo.ProvinceISO = match.code;
      } else {
        this.localData.adminInfo.Province = '';
        this.localData.adminInfo.ProvinceISO = '';
      }
    },
  },

  beforeMount() {
    $.post('/register/tab-data/admin', (data) => {
      this.localData = data;
      this.init();
    });
  },

  methods: {
    init() {
      const countryCode = this.localData.adminInfo && this.localData.adminInfo.CountryISO ?
        this.localData.adminInfo.CountryISO :
        this.localData.adminInfo.Country ? this.localData.adminInfo.Country : false;

      let country = null;
      if (!_.isEmpty(countryCode)) {
        country = _.find(this.localData.geoInfo.countries, country =>
          country.iso_code_2 === countryCode || country.Name === countryCode);

        if (country) {
          this.localCountryId = country.CountryID;
          this.localData.adminInfo.Country = country.Name;
          this.localData.adminInfo.CountryCode = country.iso_code_2;
          this.localData.adminInfo.CountryISO = country.iso_code_2;
        }
      }

      const provinceCode = this.localData.adminInfo.ProvinceISO || this.localData.adminInfo.Province;
      if (!_.isEmpty(provinceCode) && !_.isEmpty(country)) {
        const match = _.find(this.localData.geoInfo.provinces, province =>
          province.CountryID === this.localCountryId &&
            (province.code === provinceCode || province.Name === provinceCode)
        );

        if (match) {
          this.localProvinceId = match.zone_id;
          this.localData.adminInfo.Province = match.Name;
          this.localData.adminInfo.ProvinceISO = match.code;
        }
      }
    },

    saveAdminInfo() {
      if (this.checkComplete()) {
        $.post('/register/save-admin', { adminInfo: this.localData.adminInfo }, () => {
          this.$emit('display-change', this.localData);
          this.$emit('complete', true);
        });
      } else {
        toastr.error(t('register.validation_errors_found'));
      }

      return false;
    },

    checkComplete() {
      this.displayError = true;

      return !this.firstnameError && !this.lastnameError
        && !this.telError && !this.streetError
        && !this.cityError && !this.countryError
        && !this.provinceError && !this.postalError
        && !this.postalMatchError;
    },

    getProvinces() {
      return _.filter(this.localData.geoInfo.provinces, province =>
        province.CountryID === this.localCountryId);
    },
  },
};
</script>
